module.exports = __webpack_public_path__ + "img/burger.324f5b70.svg";